import request from "@/utils/request";

let PlatformActivityApi = {
    activity: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.activity/index", data, errorback);
        },
        /*修改*/
        edit(data, errorback) {
            return request._post("/merch/platformactivity.activity/edit", data, errorback);
        },
        /*删除*/
        delete(data, errorback) {
            return request._post("/merch/platformactivity.activity/delete", data, errorback);
        },
        intro(data, errorback){
            return request._get("/merch/platformactivity.activity/intro", data, errorback);
        },
        editIntro(data, errorback){
            return request._post("/merch/platformactivity.activity/editIntro", data, errorback);
        },
        rule(data, errorback){
            return request._get("/merch/platformactivity.activity/rule", data, errorback);
        },
        editRule(data, errorback){
            return request._post("/merch/platformactivity.activity/editRule", data, errorback);
        }
    },
    question: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.question/index", data, errorback);
        },
        /*添加*/
        add(data, errorback) {
            return request._post("/merch/platformactivity.question/add", data, errorback);
        },
        /*详情*/
        detail(data, errorback) {
            return request._get("/merch/platformactivity.question/detail", data, errorback);
        },
        /*修改*/
        edit(data, errorback) {
            return request._post("/merch/platformactivity.question/edit", data, errorback);
        },
        /*删除*/
        delete(data, errorback) {
            return request._post("/merch/platformactivity.question/delete", data, errorback);
        }
    },
    honor: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.honor/index", data, errorback);
        },
        /*添加*/
        add(data, errorback) {
            return request._post("/merch/platformactivity.honor/add", data, errorback);
        },
        /*详情*/
        detail(data, errorback) {
            return request._get("/merch/platformactivity.honor/detail", data, errorback);
        },
        /*修改*/
        edit(data, errorback) {
            return request._post("/merch/platformactivity.honor/edit", data, errorback);
        },
        /*删除*/
        delete(data, errorback) {
            return request._post("/merch/platformactivity.honor/delete", data, errorback);
        }
    },
    goods: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.goods/index", data, errorback);
        },
        /*添加*/
        add(data, errorback) {
            return request._post("/merch/platformactivity.goods/add", data, errorback);
        },
        /* 删除 */
        delete(data, errorback) {
            return request._post("/merch/platformactivity.goods/delete", data, errorback);
        },
        /* 推荐 */
        recommend(data, errorback) {
            return request._post("/merch/platformactivity.goods/recommend", data, errorback);
        },
        /* 详情 */
        detailgoods(data, errorback) {
            return request._post("/merch/platformactivity.goods/detail", data, errorback);
        },
        /* 编辑推荐图片 */
        editimggoods(data, errorback) {
            return request._post("/merch/platformactivity.goods/editimg", data, errorback);
        },
        changeSort(data, errorback){
            return request._post("/merch/platformactivity.goods/changeSort", data, errorback);
        }
    },
    cooperate: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.cooperate/index", data, errorback);
        },
        /*审核*/
        stateSet(data, errorback) {
            return request._post("/merch/platformactivity.cooperate/state", data, errorback);
        },
        /*详情*/
        detail(data, errorback) {
            return request._get("/merch/platformactivity.cooperate/detail", data, errorback);
        },
        /* 删除 */
        delete(data, errorback) {
            return request._post("/merch/platformactivity.cooperate/delete", data, errorback);
        }
    },
    batch: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.batch/index", data, errorback);
        },
        /*添加*/
        add(data, errorback) {
            return request._post("/merch/platformactivity.batch/add", data, errorback);
        },
        /*详情*/
        detail(data, errorback) {
            return request._get("/merch/platformactivity.batch/detail", data, errorback);
        },
        /*修改*/
        edit(data, errorback) {
            return request._post("/merch/platformactivity.batch/edit", data, errorback);
        },
        /*删除*/
        delete(data, errorback) {
            return request._post("/merch/platformactivity.batch/delete", data, errorback);
        }
    },
    order: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.order/index", data, errorback);
        },
    },
    coin: {
        /*列表*/
        list(data, errorback) {
            return request._post("/merch/platformactivity.coin/index", data, errorback);
        },
    },
};

export default PlatformActivityApi;



// WEBPACK FOOTER //
// ./src/api/platformactivity.js